import { useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import RoutesComponent from 'routers/Routes';

import errorLogger from '@picsart/growth-rc/services/errorLogger';
import { ThemeProvider } from '@picsart/growth-rc/theming';
import { withAimStyles } from '@picsart/rc/aim';
import reportWebVitals from '@picsart/rc/services/webVitals';
import { ThemeDarkValues, ThemeLightValues } from '@picsart/design-system/foundation/colors';
import { useFoundation } from '@picsart/design-system/foundation/initFoundation';

import ModalContainer from 'components/ModalContainer';
import { errorLoggerConfig } from 'constants/main';
import { CMS_API_URL } from 'utils/endpoints';

/**
 * useFoundation({ fonts, themes, writingMode })
 * Generates and applies foundation styles, including fonts, themes, writing modes, and other global styles.
 * */

const themes = [
  {
    key: 'light',
    value: ThemeLightValues,
    selected: true,
  },
  {
    key: 'dark',
    value: ThemeDarkValues,
    selected: false,
  },
];

function App({ version }: { version?: string }) {
  withAimStyles();
  reportWebVitals(window.location.href);
  useFoundation({ themes });

  useEffect(() => {
    if (version) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // eslint-disable-next-line no-console
      console.log(version, 'revision version');

      errorLogger
        .init({
          ...errorLoggerConfig,
          appVersion: version,
        })
        .catch(e => {
          console.error('Can not init bugsnag', e);
        });
    }
  }, [version]);

  return (
    <HelmetProvider>
      <Helmet>
        <link rel="preconnect" href={CMS_API_URL} />
      </Helmet>
      <ThemeProvider>
        <RoutesComponent />
        <ModalContainer />
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
